export default __webpack_public_path__ + "static/dymaxion-dash-fa8e77f6702fb29440cd37f19b2724f8.png";